import {
  requestAesexy,
  requestAg,
  requestOmg,
  requestCDN,
  requestCQ9,
  requestCRSPORT,
  requestEvo,
  requestEvoplay,
  requestFBSPORT,
  requestFC,
  requestFCFish,
  requestFFFLive,
  requestGlobalSettingData,
  requestJDBFish,
  requestJDBSlot,
  requestJili,
  requestJollySport,
  requestLuckySport,
  requestMain,
  requestMg,
  requestMiniGame,
  requestONEEVOLIVE,
  requestONEGLOBAL,
  requestONEHACKSAW,
  requestONEJDBFISH,
  requestONEJDBSLOT,
  requestONEJILICARD,
  requestONEJILICASINO,
  requestONEJILIFISH,
  requestONEJILISLOT,
  requestONEPG,
  requestONEPP,
  requestONEPPLIVE,
  requestONESABA,
  requestPPLive,
  requestPT,
  requestPg,
  requestPlayStar,
  requestPp,
  requestSBOSPORT,
  requestSpribe,
  requestSpribeone,
  requestT1,
  requestTcg,
  requestViaCasinoLive,
  requestWCF,
  requestWeblockchain,
  requestWefish,
  requestWelive,
  requestWelottery,
  requestWeslot,
  requestWesport,
  requestYbslot,
  requestYgg,
  requestYoubet,
} from "../../apis";
import axios from "axios";
import localStorageKey from "../../enumerations/localStorageKey";

const currency =
  window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
  process.env.REACT_APP_DEFAULT_CURRENCY;
const lang = window.localStorage.getItem(localStorageKey.LANG_SETTING);

export const apiGetBanner = (params) =>
  requestGlobalSettingData("get", `/${currency}/banner`, params, false, false);

export const apiGetPromotionBanner = (params) =>
  requestMain("get", `/${currency}/promotion/show/banner`, params, false, false);

export const apiGetAllBanner = (params) => {
  const millis = Date.now();
  return requestCDN(
    "get",
    `/${currency?.toUpperCase()}/promotion/global-banner/${
      lang ? lang : process.env.REACT_APP_DEFAULT_LANG
    }.json?v=${millis}`,
  );
  // return requestMain("get", `/${currency}/promotion/global/banner`, params, false, false);
};

export const apiGetGameTypes = (params) =>
  requestGlobalSettingData("get", `/${currency}/game/category`, params, false, false);

export const apiGetGameListByType = (params, gameTypeID) =>
  requestGlobalSettingData("get", `/${currency}/game/${gameTypeID}`, params, false, false);

export const apiRedirectToGame = (params) =>
  requestMain("post", `/${currency}/game/login`, params, true, false);

export const apiGetMessage = (params) =>
  requestMain("get", `/${currency}/message`, params, true, false);

export const getWinGameList = (params) =>
  requestGlobalSettingData("get", `/${currency}/game/win/list`, params, true);

//
export const apiGetMgGameLoginUrl = (params) =>
  requestMg("get", `/${currency}/game/login`, params, true);

export const apiGetT1LoginUrl = (params) =>
  requestT1("post", `/${currency}/user/login`, params, true);

export const getT1GameList = (params) => requestT1("get", `/${currency}/game`, params, true);

export const getEvoGameUrl = (params) =>
  requestEvo("post", `/${currency}/user/login`, params, true);

export const apiGetPpGameLoginUrl = (params) =>
  requestPp("post", `/${currency}/user/login`, params, true);

export const getPpGameList = (params) => requestPp("get", `/${currency}/game`, params, true);

//pg
export const apiGetPgGameLoginUrl = (params) =>
  requestPg("post", `/${currency}/user/login`, params, true);

export const getPgGameList = (params) => requestPg("get", `/${currency}/game`, params, true);

//ygg
export const apiGetYggGameLoginUrl = (params) =>
  requestYgg("post", `/${currency}/user/login`, params, true);

export const getYggGameList = (params) => requestYgg("get", `/${currency}/game`, params, true);

//evoplay
export const apiGetEvoplayGameLoginUrl = (params) =>
  requestEvoplay("post", `/${currency}/user/login`, params, true);

export const getEvoplayGameList = (params) =>
  requestEvoplay("get", `/${currency}/game`, params, true);

//jili
export const apiGetJiliGameLoginUrl = (params) =>
  requestJili("post", `/${currency}/user/login`, params, true);

export const getJiliGameList = (params) => requestJili("get", `/${currency}/game`, params, true);

//spribe
export const apiGetSpribeGameLoginUrl = (params) =>
  requestSpribe("post", `/${currency}/user/login`, params, true);

export const getSpribeGameList = (params) =>
  requestSpribe("get", `/${currency}/game`, params, true);

//PT
export const apiGetPTGameLoginUrl = (params) =>
  requestPT("post", `/${currency}/user/login`, params, true);

export const getPTGameList = (params) => requestPT("get", `/${currency}/game`, params, true);

//PPLIVE
export const apiGetPPLiveGameLoginUrl = (params) =>
  requestPPLive("post", `/${currency}/user/login`, params, true);

export const getPPLIveGameList = (params) =>
  requestPPLive("get", `/${currency}/game`, params, true);

//FC
export const apiGetFCGameLoginUrl = (params) =>
  requestFC("post", `/${currency}/user/login`, params, true);

export const getFCGameList = (params) => requestFC("get", `/${currency}/game`, params, true);
//CQ9
export const apiGetCQ9GameLoginUrl = (params) =>
  requestCQ9("post", `/${currency}/user/login`, params, true);

export const getCQ9GameList = (params) => requestCQ9("get", `/${currency}/game`, params, true);
//PLAYSTAR
export const apiGetPlayStarGameLoginUrl = (params) =>
  requestPlayStar("post", `/${currency}/user/login`, params, true);
export const getPlayStarGameList = (params) =>
  requestPlayStar("get", `/${currency}/game`, params, true);

//WELOTTERY
export const apiGetWelotteryGameLoginUrl = (params) =>
  requestWelottery("post", `/${currency}/user/login`, params, true);
export const getWelotteryGameList = (params) =>
  requestWelottery("get", `/${currency}/game`, params, true);

//WELIVE
export const apiGetWeliveGameLoginUrl = (params) =>
  requestWelive("post", `/${currency}/user/login`, params, true);
export const getWeliveGameList = (params) =>
  requestWelive("get", `/${currency}/game`, params, true);

//WEBLOCKCHAIN
export const apiGetWeblockchainGameLoginUrl = (params) =>
  requestWeblockchain("post", `/${currency}/user/login`, params, true);
export const getWeblockchainGameList = (params) =>
  requestWeblockchain("get", `/${currency}/game`, params, true);

//TCG
export const apiGetTcgGameLoginUrl = (params) =>
  requestTcg("post", `/${currency}/user/login`, params, true);
export const getTcgGameList = (params) => requestTcg("get", `/${currency}/game`, params, true);

//YOUBET
export const apiGetYoubetGameLoginUrl = (params) =>
  requestYoubet("post", `/${currency}/user/login`, params, true);
export const getYoubetGameList = (params) =>
  requestYoubet("get", `/${currency}/game`, params, true);

//AESEXY
export const apiGetAesexyGameLoginUrl = (params) =>
  requestAesexy("post", `/${currency}/user/login`, params, true);
export const getAesexyGameList = (params) =>
  requestAesexy("get", `/${currency}/game`, params, true);

//SPRIBE ONE
export const apiGetSpribeoneGameLoginUrl = (params) =>
  requestSpribeone("post", `/${currency}/user/login`, params, true);
export const getSpribeoneGameList = (params) =>
  requestSpribeone("get", `/${currency}/game`, params, true);

//WE SPORT
export const apiGetWesportGameLoginUrl = (params) =>
  requestWesport("post", `/${currency}/user/login`, params, true);
export const getWesportGameList = (params) =>
  requestWesport("get", `/${currency}/game`, params, true);

//LUCKY SPORT
export const apiGetLuckySportGameLoginUrl = (params) =>
  requestLuckySport("post", `/${currency}/user/login`, params, true);
export const getLuckySportGameList = (params) =>
  requestLuckySport("get", `/${currency}/game`, params, true);

//YB SLOT
export const apiGetYbslotGameLoginUrl = (params) =>
  requestYbslot("post", `/${currency}/user/login`, params, true);
export const getYbslotGameList = (params) =>
  requestYbslot("get", `/${currency}/game`, params, true);

//WE FISH
export const apiGetWefishGameLoginUrl = (params) =>
  requestWefish("post", `/${currency}/user/login`, params, true);
export const getWefishGameList = (params) =>
  requestWefish("get", `/${currency}/game`, params, true);

//WESLOT
export const apiGetWeslotGameLoginUrl = (params) =>
  requestWeslot("post", `/${currency}/user/login`, params, true);
export const getWeslotGameList = (params) =>
  requestWeslot("get", `/${currency}/game`, params, true);

// FC FISH
export const apiGetFCFishGameLoginUrl = (params) =>
  requestFCFish("post", `/${currency}/user/login`, params, true);
export const getFCFishGameList = (params) =>
  requestFCFish("get", `/${currency}/game`, params, true);

//JDB FISH
export const apiGetJDBFishGameLoginUrl = (params) =>
  requestJDBFish("post", `/${currency}/user/login`, params, true);
export const getJDBFishGameList = (params) =>
  requestJDBFish("get", `/${currency}/game`, params, true);

//JDB SLOT
export const apiGetJDBSlotGameLoginUrl = (params) =>
  requestJDBSlot("post", `/${currency}/user/login`, params, true);
export const getJDBSlotGameList = (params) =>
  requestJDBSlot("get", `/${currency}/game`, params, true);

//VIA CASINO LIVE
export const apiGetViaCasinoLiveGameLoginUrl = (params) =>
  requestViaCasinoLive("post", `/${currency}/user/login`, params, true);
export const getViaCasinoLiveGameList = (params) =>
  requestViaCasinoLive("get", `/${currency}/game`, params, true);

//FFF LIVE
export const apiGetFFFLiveGameLoginUrl = (params) =>
  requestFFFLive("post", `/${currency}/user/login`, params, true);
export const getFFFLiveGameList = (params) =>
  requestFFFLive("get", `/${currency}/game`, params, true);

//WCF LIVE
export const apiGetWCFGameLoginUrl = (params) =>
  requestWCF("post", `/${currency}/user/login`, params, true);
export const getWCFGameList = (params) => requestWCF("get", `/${currency}/game`, params, true);

//JOLLY SPORT
export const apiGetJollySportGameLoginUrl = (params) =>
  requestJollySport("post", `/${currency}/user/login`, params, true);

//ONE JDB SLOT
export const apiGetONEJDBSLOTGameLoginUrl = (params) =>
  requestONEJDBSLOT("post", `/${currency}/user/login`, params, true);
export const getONEJDBSLOTGameList = (params) =>
  requestONEJDBSLOT("get", `/${currency}/game`, params, true);

// ONE JDB FISH
export const apiGetONEJDBFISHGameLoginUrl = (params) =>
  requestONEJDBFISH("post", `/${currency}/user/login`, params, true);
export const getONEJDBFISHGameList = (params) =>
  requestONEJDBFISH("get", `/${currency}/game`, params, true);

// ONE PP
export const apiGetONEPPGameLoginUrl = (params) =>
  requestONEPP("post", `/${currency}/user/login`, params, true);
export const getONEPPGameList = (params) => requestONEPP("get", `/${currency}/game`, params, true);

// ONE PG
export const apiGetONEPGGameLoginUrl = (params) =>
  requestONEPG("post", `/${currency}/user/login`, params, true);
export const getONEPGGameList = (params) => requestONEPG("get", `/${currency}/game`, params, true);

// ONE HACKSAW
export const apiGetONEHACKSAWGameLoginUrl = (params) =>
  requestONEHACKSAW("post", `/${currency}/user/login`, params, true);
export const getONEHACKSAWHGameList = (params) =>
  requestONEHACKSAW("get", `/${currency}/game`, params, true);

// ONE JILI SLOT
export const apiGetONEJILISLOTGameLoginUrl = (params) =>
  requestONEJILISLOT("post", `/${currency}/user/login`, params, true);
export const getONEJILISLOTGameList = (params) =>
  requestONEJILISLOT("get", `/${currency}/game`, params, true);

//ONE JILI FISH
export const apiGetONEJILIFISHGameLoginUrl = (params) =>
  requestONEJILIFISH("post", `/${currency}/user/login`, params, true);
export const getONEJILIFISHGameList = (params) =>
  requestONEJILIFISH("get", `/${currency}/game`, params, true);

//ONE JILI CARD
export const apiGetONEJILICARDGameLoginUrl = (params) =>
  requestONEJILICARD("post", `/${currency}/user/login`, params, true);
export const getONEJILICARDGameList = (params) =>
  requestONEJILICARD("get", `/${currency}/game`, params, true);

//ONE JILI CASINO
export const apiGetONEJILICASINOGameLoginUrl = (params) =>
  requestONEJILICASINO("post", `/${currency}/user/login`, params, true);
export const getONEJILICASINOGameList = (params) =>
  requestONEJILICASINO("get", `/${currency}/game`, params, true);

//ONE EVO LIVE
export const apiGetONEEVOLIVEGameLoginUrl = (params) =>
  requestONEEVOLIVE("post", `/${currency}/user/login`, params, true);
export const getONEEVOLIVEGameList = (params) =>
  requestONEEVOLIVE("get", `/${currency}/game`, params, true);

//ONE PP LIVE
export const apiGetONEPPLIVEGameLoginUrl = (params) =>
  requestONEPPLIVE("post", `/${currency}/user/login`, params, true);
export const getONEPPLIVEGameList = (params) =>
  requestONEPPLIVE("get", `/${currency}/game`, params, true);

//ONE SABA
export const apiGetONESABAGameLoginUrl = (params) =>
  requestONESABA("post", `/${currency}/user/login`, params, true);
export const getONESABAGameList = (params) =>
  requestONESABA("get", `/${currency}/game`, params, true);

//ONE GLOBAL
export const apiGetONEGLOBALGameLoginUrl = (params) =>
  requestONEGLOBAL("post", `/${currency}/user/login`, params, true);
export const getONEGLOBALGameList = (params) =>
  requestONEGLOBAL("get", `/${currency}/game`, params, true);

// AG
export const apiGetAgGameLoginUrl = (params) =>
  requestAg("post", `/${currency}/user/login`, params, true);
export const getAgGameList = (params) => requestAg("get", `/${currency}/game`, params, true);
// AG 試玩：未登入，走 AG 後端的試玩商戶
// 網址用試算表 AG_TRIAL_API (試玩獨立機器)，沒設沿用 AG_MAIN_API
// 不走 req()，避免錯誤攔截器把訪客 logout / 導去登入
const AG_TRIAL_API = process.env.REACT_APP_AG_TRIAL_API || process.env.REACT_APP_AG_MAIN_API;
export const apiGetAgTrialGameUrl = (params) =>
  axios.post(
    `${process.env.REACT_APP_PROTOCOL}://${AG_TRIAL_API}/${currency}/user/trial/login`,
    params,
    { headers: { "Content-Type": "application/json" } },
  );

// OMG
export const apiGetOmgGameLoginUrl = (params) =>
  requestOmg("post", `/${currency}/user/login`, params, true);
export const getOmgGameList = (params) => requestOmg("get", `/${currency}/game`, params, true);

// OMG 試玩：未登入直接打 OMG 官方試玩接口，不經後端、不需簽名
// 不走 req()，避免帶上自訂 header 被 CORS 擋，以及錯誤攔截器把訪客導去登入
const OMG_DEMO_URL = `https://${process.env.REACT_APP_OMG_DEMO_API || "api.omgapi.cc"}`;
export const apiGetOmgDemoGames = () => axios.get(`${OMG_DEMO_URL}/api/v1/pg/live-api/games`);
export const apiGetOmgDemoGameUrl = (params) =>
  axios.post(`${OMG_DEMO_URL}/api/usr/ingame`, params, {
    headers: { "Content-Type": "application/json" },
  });

//MINI GAME
export const apiGetMiniGameGameLoginUrl = (params) =>
  requestMiniGame("post", `/${currency}/user/login`, params, true);
export const getMiniGameGameList = (params) =>
  requestMiniGame("get", `/${currency}/game`, params, true);

//SBO SPORT
export const apiGetSBOSPORTGameLoginUrl = (params) =>
  requestSBOSPORT("post", `/${currency}/user/login`, params, true);
export const getSBOSPORTGameList = (params) =>
  requestSBOSPORT("get", `/${currency}/game`, params, true);

//CR SPORT
export const apiGetCRSPORTGameLoginUrl = (params) =>
  requestCRSPORT("post", `/${currency}/user/login`, params, true);
export const getCRSPORTGameList = (params) =>
  requestCRSPORT("get", `/${currency}/game`, params, true);

//FB SPORT
export const apiGetFBSPORTGameLoginUrl = (params) =>
  requestFBSPORT("post", `/${currency}/user/login`, params, true);
export const getFBSPORTGameList = (params) =>
  requestFBSPORT("get", `/${currency}/game`, params, true);

//1bbetv2
export const apiGetGameCategoryV2 = (params) =>
  requestGlobalSettingData("get", `/${currency}/game/v1/category/list`, params, false, false);

export const apiGetHotGameV2 = (params) =>
  requestGlobalSettingData("get", `/${currency}/game/v1/hot/list`, params, false, false);

export const apiGetGameV2 = (params) =>
  requestGlobalSettingData(
    "get",
    `/${currency}/game/v1/combine/category/hot/list`,
    params,
    false,
    false,
  );
